import gsap from 'gsap';
import { SliderClick } from '../_app/cuchillo/components/SliderClick';
import { isMobile, isTouch } from '../_app/cuchillo/core/Basics';
import Keyboard from '../_app/cuchillo/core/Keyboard';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Header from '../layout/Header';
import NoScroll from './NoScroll';

export default class Gallery extends NoScroll {
  _slider;

  constructor() {
    super();

    this._slider = new SliderClick(this.container);
  }

  beforeShow() {
    if (this._slider) this._slider.show();
    // No se porque habia aqui scroll
    // Scroll.init(Scroll.AXIS_Y, { domResize: this.container, smooth: !isTouch, multiplicator: 1 });
    Keyboard.mountPage(this.id);

    if (this.isFirstTime) {
      Header.directShow();
    }
  }

  afterShow() {
    super.afterShow();
  }

  afterHide() {
    super.afterHide();
    if (this._slider) this._slider.dispose();

    Header.mode = Header.MODE_SEMI;
  }
}

ControllerPage._addPage('gallery', Gallery);
